import { render, staticRenderFns } from "./newPencilIcon.vue?vue&type=template&id=4fb5c95c"
import script from "./newPencilIcon.vue?vue&type=script&lang=js"
export * from "./newPencilIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports